import gql from 'graphql-tag'

export const MUTATION_SINGLE_UPLOAD_BASE64 = gql`
  mutation SingleUploadBase64($filename: String!, $base64: String!) {
    singleUploadBase64(filename: $filename, base64: $base64) {
      filename
      mimetype
      url
    }
  }
`

export const MUTATION_CHECK_AND_UPLOAD_USERS_FROM_FILE = gql`
  mutation CheckAndUploadUsersFromFile($input: CheckUsersFromFileInput!) {
    checkAndUploadUsersFromFile(input: $input) {
      fileUrl
      founded
      notFounded
      wasUploaded
    }
  }
`

export const QUERY_REFRESH = gql`
  query refreshToken {
    refreshToken
  }
`

export const QUERY_ZENDESK_CHAT_TOKEN = gql`
  query zendeskWidgetToken($userEmail: String!) {
    zendeskWidgetToken(userEmail: $userEmail) {
      token
      version
    }
  }
`

export const QUERY_SINGLE_LOGIN = gql`
  query loginWithAuthCode($authCode: String!) {
    loginWithAuthCode(authCode: $authCode) {
      ecommerceFlag
      useCatalogFlag
      cbmFlag
      user {
        _id
        name
        login
        pages
        multi_user
        mf
        admin
        profiles
        email_confirmed
        ecommerce
        club
        has_pii_access
        has_pii_employees_access
        has_pii_download_data_permission
        ecommercePermissions
        account {
          _id
          integration_type
          name
          franchise_id
          id_external
          modules
          is_franchise
          is_franchisee
          only_mercapromo
          has_mercapromo
          db_name
          channels {
            ecommerce_v2 {
              active
              integration {
                url
              }
            }
          }
          cbm_configuration {
            recency_criteria {
              actives {
                bought
                not_bought
              }
              recent_inactives {
                bought
                not_bought
              }
              at_risk {
                bought
                not_bought
              }
              losses {
                bought
                not_bought
              }
            }
          }
          security {
            phone_required
          }
        }
      }
    }
  }
`

export const MUTATION_REFRESH_SESSION = gql`
  mutation RefreshSession {
    refreshSession
  }
`
